import React, { useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Enumber = ({ filteredEnumbers }) => {
  const [showCount, setShowCount] = useState(15);

  const getBackgroundColor = (tag) => {
    switch (tag) {
      case "Halal":
        return "#40916c";
      case "Haram":
        return "#d62839";
      case "Doubtful":
        return "#ffef9f";
      default:
        return "white";
    }
  };

  const handleLoadMore = () => {
    setShowCount((prevCount) => prevCount + 15);
  };

  return (
    <Container style={{ marginTop: "10%" }}>
      {filteredEnumbers?.length === 0 ? (
        <Typography
          variant="body1"
          style={{ textAlign: "center", fontFamily: "Poppins, sans-serif" }}
        >
          No Data Found
        </Typography>
      ) : (
        <Grid container spacing={3}>
          {filteredEnumbers?.slice(0, showCount).map((enumber) => (
            <Grid item xs={12} sm={6} md={4} key={enumber._id}>
              <Card
                style={{
                  height: "100%",
                  backgroundColor: getBackgroundColor(enumber.Tag),
                }}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    style={{ fontFamily: "Poppins, sans-serif" }}
                  >
                    {enumber.Number} - {enumber.Tag}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: "10px",
                      marginBottom: "5px",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    {enumber.Name}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{ fontFamily: "Poppins, sans-serif" }}
                  >
                    <strong>Type:</strong> {enumber.Type}
                    <Tooltip
                      title={
                        <>
                          {enumber.HalalStatusFirst && (
                            <div
                              style={{
                                fontFamily: "Poppins, sans-serif",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CheckCircleOutlineIcon
                                style={{ marginRight: "5px" }}
                              />
                              {enumber.HalalStatusFirst}
                            </div>
                          )}
                          {enumber.HalalStatusSecond && (
                            <div
                              style={{
                                fontFamily: "Poppins, sans-serif",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "5px",
                              }}
                            >
                              <CheckCircleOutlineIcon
                                style={{ marginRight: "5px" }}
                              />
                              {enumber.HalalStatusSecond}
                            </div>
                          )}
                        </>
                      }
                      placement="top"
                    >
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      {filteredEnumbers.length > showCount && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            variant="contained"
            style={{
              fontFamily: "Poppins, sans-serif",
              color: "#fff",
              backgroundColor: "#003566",
            }}
            onClick={handleLoadMore}
          >
            Load More...
          </Button>
        </div>
      )}
    </Container>
  );
};

export default Enumber;
